<template>
    <!--密码重置成功-->
    <div class="forgetPwd" :style="{height:height}">
        <div class='content'>
            <div class="main_title">{{ name }}</div>
            <!--<div class="sub_title">找到浩方源，幸福从这里开始</div>-->
            <div class="box">
                <div class="icon_box">
                    <i class="iconfont">&#xe7f8;</i>
                    <span>密码重置成功</span>
                </div>
                <button type='button' class="btn" @click="$router.push('/login')">去登录</button>
            </div>
        </div>

    </div>
</template>

<script type="text/ecmascript-6">
	export default {
		data() {
			return {
				height: '',
				name: ''
			}
		},
		created() {
			this.height = window.screen.availHeight - 103 + 'px'
			this.name = localStorage.getItem('meta_title')
		},
		methods: {}
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    /*@import "../app/app";*/
    .icon_box {
        display: flex;
        flex-direction: column;
        margin-bottom: 60px;
        align-items: center;
        i {
            font-size: 90px;
            color: #50B3FF;
        }
        span {
            color: #50B3FF;
        }
    }
</style>